module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":["Here you will find a log of significant actions performed on this server. Changes made to user, Project, or Form settings can be found here."],"emptyTable":"There are no matching audit log entries."}}')
  delete Component.options._Ctor
}
